import { Data } from '@mdqx/types/dist/proto/leadApp/data';
import { GetTimeFromTimestamp, Link as LeadAppLink } from '@mdqx/types';

export enum LeadAppLinkStatusEnum {
    NEW = "NEW",
    SENT = "SENT",
    OPENED = "OPENED",
    SUBMITTED = "SUBMITTED",
    CLOSED = "CLOSED",
    PROCESSING = "PROCESSING",
    CONTROLLED = "CONTROLLED",
    SIGNED = "SIGNED",
}

export const LeadAppLinkStatusTypeNames: Map<LeadAppLinkStatusEnum, string> = new Map<LeadAppLinkStatusEnum, string>([
    [LeadAppLinkStatusEnum.NEW, 'Neu'],
    [LeadAppLinkStatusEnum.SENT, 'Versendet'],
    [LeadAppLinkStatusEnum.OPENED, 'Geöffnet'],
    [LeadAppLinkStatusEnum.SUBMITTED, 'Daten übermittelt'],
    [LeadAppLinkStatusEnum.CLOSED, 'Geschlossen'],
    [LeadAppLinkStatusEnum.PROCESSING, 'In Bearbeitung'],
    [LeadAppLinkStatusEnum.CONTROLLED, 'Kontrolliert'],
    [LeadAppLinkStatusEnum.SIGNED, 'Unterschrieben'],
]);

export class LeadAppLinkEntity {
    constructor(
        public Id: number = null,
        public Name?: string,
        public Number?: string,
        public PartnerId: number = null,
        public CustomerId: number = null,
        public ExpiryDate: Date = null,
        public CreatedAt: Date = null,
        public UpdatedAt: Date = null,
        public DeletedAt?: Date,
        public Data: Data | undefined = null,
        public Status: LeadAppLinkStatusEnum | null = null,
        public NewCustomer: boolean | null = null,
    ) {}

    public static EntityName = 'Leads';

    public Clone(override: Partial<LeadAppLinkEntity> = {}): LeadAppLinkEntity {
        const attr = { ...this, ...override };
        return Object.assign(new LeadAppLinkEntity(), attr);
    }
}

export function LeadAppLinkEntityFromBackend(res: LeadAppLink): LeadAppLinkEntity {
    const statusEnumValue = res.Status ? LeadAppLinkStatusEnum[res?.Status] : null;

    return new LeadAppLinkEntity(
        res.Id && +res.Id,
        res.Name,
        res.Number,
        res.PartnerId && +res.PartnerId,
        res.CustomerId && +res.CustomerId,
        GetTimeFromTimestamp(+res.ExpiryDate),
        GetTimeFromTimestamp(+res.CreatedAt),
        GetTimeFromTimestamp(+res.UpdatedAt),
        GetTimeFromTimestamp(+res.DeletedAt),
        res.Data,
        statusEnumValue,
        res.NewCustomer,
    );
}
